<script setup lang="ts">
  import { computed } from 'vue';
  import { modalContentClass, scrollableClass } from './ModalContent.css';
  import type { ModalContentProps } from './ModalContent.types';

  const props = withDefaults(defineProps<ModalContentProps>(), {
    scrollable: false,
  });

  const contentClasses = computed(() => ({
    [modalContentClass]: true,
    [scrollableClass]: props.scrollable,
  }));
</script>

<template>
  <div :class="contentClasses"><slot /></div>
</template>
